var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAthletic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 271,
    viewBox: "0 0 297 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.5 249C203.707 249 259 193.707 259 125.5C259 57.2928 203.707 2 135.5 2C67.2928 2 12 57.2928 12 125.5C12 193.707 67.2928 249 135.5 249Z",
    fill: "#AEDAEA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 125.5,
    r: 108.5,
    fill: "#E1F1F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.618 22.3373C218.94 27.0916 204.678 27.7254 192 17.5831V57.2013C192 57.2013 209.432 65.1249 226.864 60.3707C237.995 57.3352 250.635 47.6929 268.067 60.3707V23.922C255.389 12.512 244.296 17.5831 231.618 22.3373Z",
    fill: "#AB6FC3",
    stroke: "#143860",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 90L192 49",
    stroke: "#143860",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 57.3225L78.0592 20.918H92.3315H142.284H158.935L196.994 57.3225L168.45 84.6258L156.556 73.2494V146.058H78.0592V73.2494L66.1657 84.6258L40 57.3225Z",
    fill: "#167BA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.996 54.4045L82.0552 18H96.3274C96.3274 18 99.8955 37.3399 120.114 37.3399C140.333 37.3399 146.28 18 146.28 18H162.931L200.99 54.4045L172.446 81.7079L160.552 70.3315V143.14H82.0552V70.3315L70.1617 81.7079L43.996 54.4045Z",
    stroke: "#143860",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.052 18H150.934",
    stroke: "#143860",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.552 92.3257C117.69 92.3257 117.802 92.2135 117.802 92.0753L117.754 65.3721C117.754 65.1592 117.504 65.042 117.338 65.176C115.403 66.7441 111.277 69.7239 110.354 70.3876C110.248 70.4642 110.104 70.4429 110.02 70.3423L105.6 65.0382C105.507 64.927 105.528 64.7606 105.645 64.6757L119.764 54.4518C119.807 54.4209 119.858 54.4043 119.911 54.4043H128.88C129.018 54.4043 129.13 54.5162 129.13 54.6543V92.0757C129.13 92.2138 129.242 92.3257 129.38 92.3257H138.359C138.497 92.3257 138.609 92.4377 138.609 92.5757V99.66C138.609 99.7981 138.497 99.91 138.359 99.91H106.626C106.488 99.91 106.376 99.7981 106.376 99.66V92.5757C106.376 92.4377 106.488 92.3257 106.626 92.3257H117.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.506 183.079C141.736 135.557 99.9307 154.154 73.175 183.091C72.4961 183.826 72.4878 184.959 73.1461 185.712C105.675 222.904 153.11 224.772 186.582 185.729C187.233 184.969 187.193 183.808 186.506 183.079Z",
    fill: "white",
    stroke: "#143860",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103,
    y1: 160,
    x2: 103,
    y2: 208,
    stroke: "#143860",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 160,
    x2: 155,
    y2: 209,
    stroke: "#143860",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167,
    y1: 166,
    x2: 167,
    y2: 203,
    stroke: "#143860",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.888,
    y1: 178.941,
    x2: 118.888,
    y2: 188.912,
    stroke: "#143860",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.864,
    y1: 178.941,
    x2: 128.864,
    y2: 188.912,
    stroke: "#143860",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.839,
    y1: 178.941,
    x2: 138.839,
    y2: 188.912,
    stroke: "#143860",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91,
    y1: 167,
    x2: 91,
    y2: 202,
    stroke: "#143860",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0152 127.485C68.4027 127.307 68.4027 126.756 68.0152 126.577L58.4846 122.184C58.1993 122.052 57.9708 121.822 57.8392 121.536L53.4544 111.989C53.276 111.6 52.724 111.6 52.5456 111.989L48.1608 121.536C48.0292 121.822 47.7997 122.052 47.5154 122.184L37.9848 126.577C37.5973 126.756 37.5973 127.307 37.9848 127.485L47.5154 131.88C47.7997 132.012 48.0292 132.242 48.1608 132.527L52.5456 142.075C52.724 142.463 53.276 142.463 53.4544 142.075L57.8392 132.527C57.9708 132.242 58.1993 132.012 58.4846 131.88L68.0152 127.485Z",
    fill: "#F15A29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 120,
    rx: 4,
    ry: 4,
    transform: "rotate(-180 28 120)",
    fill: "#7E3F97"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.5,
    cy: 170.5,
    rx: 2.5,
    ry: 2.5,
    transform: "rotate(-180 37.5 170.5)",
    fill: "#167BA5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.5,
    cy: 94.5,
    rx: 2.5,
    ry: 2.5,
    transform: "rotate(-180 50.5 94.5)",
    fill: "#E6126A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.706,
    cy: 130.706,
    r: 44.706,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.294,
    cy: 126.907,
    r: 43.706,
    stroke: "#143860",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.016 92.9297C235.659 108.13 235.659 142.106 257.118 160.883",
    stroke: "#143860",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.47 92.9297C225.827 108.13 225.828 142.106 204.368 160.883",
    stroke: "#143860",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.376 127.801C188.091 127.801 244.898 127.801 273.212 127.801",
    stroke: "#143860",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0152 150.97C77.4027 150.791 77.4027 150.24 77.0152 150.062L73.0709 148.243C72.9372 148.182 72.8301 148.074 72.7684 147.94L70.9544 143.99C70.776 143.602 70.224 143.602 70.0456 143.99L68.2316 147.94C68.1699 148.074 68.0624 148.182 67.9291 148.243L63.9848 150.062C63.5973 150.24 63.5973 150.791 63.9848 150.97L67.9291 152.789C68.0624 152.851 68.1699 152.958 68.2316 153.092L70.0456 157.042C70.224 157.43 70.776 157.43 70.9544 157.042L72.7684 153.092C72.8301 152.958 72.9372 152.851 73.0709 152.789L77.0152 150.97Z",
    fill: "#E6126A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: 0,
    y: 0,
    width: 287,
    height: 271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthletic);
export default __webpack_public_path__ + "static/media/Athletic.0cfb52149fa26579fcda591d054f1beb.svg";
export { ForwardRef as ReactComponent };